import React, { Component, createRef } from 'react'
import Utils from '../../common/Utils'
import UFT from '../../common/UserFacingText'
import DisplaySchema from '../common/displaySchema/schemas/DisplaySchema'
import DisplayTypes from '../common/displaySchema/displayTypes/DisplayTypes'
import DSFormCP from '../common/displaySchema/DSFormCP'


// BIG  TODO: the seem between DSForm and the user (like this one) is pretty clunky. Fix it

class NewUserCP extends Component {
  constructor (props) {
    super(props)

    this.formEle = createRef()

    this.onSubmit = (formVals) => {}
    if ('onSubmit' in props) this.onSubmit = props.onSubmit

    this.initFormVals = {
      'playerName': '',
      'email': '',
      'emailConfirm':'',
    }

    this.initFormMeta = new DisplaySchema({
      displayName: 'New Player',
      displayType: DisplayTypes['COLLECTION'].id,
      properties: {
        playerName: new DisplaySchema({
          displayName: 'Name',
          displayType: DisplayTypes['TEXT'].id,
          displayOrder: 2
        }),
        email: new DisplaySchema({
          displayName: 'Email',
          displayType: DisplayTypes['TEXT'].id,
          displayOrder: 2
        }),
        emailConfirm: new DisplaySchema({
          displayName: 'Confirm Email',
          displayType: DisplayTypes['TEXT'].id,
          displayOrder: 2
        }),
      }
    })

    this.formVals = Utils.clone(this.initFormVals)

    this.state = {
      'isFormValid': true,
    }
  }

  // --- interface --- //
  resetForm () {
    this.formEle.current.resetForm()
  }

  // --- //

  validateForm (formVals, formMeta) {
    let isFormValid = true
    formMeta.properties.playerName.invalidMessage = ''
    formMeta.properties.email.invalidMessage = ''

    if (!formVals.playerName || formVals.playerName === '') {
      isFormValid = false
      formMeta.properties.playerName.invalidMessage = UFT.NAME_SHOULD_NOT_BE_BLANK
    }

    if (formVals.email !== formVals.emailConfirm) {
      isFormValid = false
      formMeta.properties.email.invalidMessage = UFT.EMAIL_DOESNT_MATCH
    } else if (!formVals.email || formVals.email === '') {
      isFormValid = false
      formMeta.properties.email.invalidMessage = UFT.EMAIL_SHOULD_NOT_BE_BLANK
    }

    return {isFormValid, formMeta, formVals}
  }

  onFormChange (formVals, isFormValid) {
    this.setState({
      'isFormValid': isFormValid,
    })
  }

  _submit (event) {
    let {formVals, formMeta, isFormValid} = this.formEle.current.onSubmit()
    this.setState({
      'isFormValid': isFormValid,
    })

    if (isFormValid) {
      // send the info to the server
      console.log('NEW PLAYER:', formVals)
      this.onSubmit(formVals)
    }
  }

  render () {
    return <>
      <DSFormCP ref={this.formEle} 
        formMeta={this.initFormMeta} 
        initFormVals={this.initFormVals} 
        validateForm={(formVals, formMeta) => this.validateForm(formVals, formMeta)} 
        onFormChange={(formVals, isFormValid) => this.onFormChange(formVals, isFormValid)} 
      />
      <div className='spacerEle'></div>
      <div className='spacerEle'>
        <button className='bcioButton' role='' disabled={!this.state.isFormValid} onClick={event => this._submit(event)} >new player</button>
      </div>
    </>
  }

}

export default NewUserCP
